import request from '@/api/http'

// 获取任务配置
export function getTask() {
  return request({
    url: '/material/fb-scrape/task',
    method: 'get'
  })
}

// 保存/更新任务配置
export function saveTask(data) {
  return request({
    url: '/material/fb-scrape/task',
    method: 'post',
    data: data
  })
}

// 启动任务
export function startTask() {
  return request({
    url: '/material/fb-scrape/start',
    method: 'post'
  })
}

// 暂停任务
export function pauseTask() {
  return request({
    url: '/material/fb-scrape/pause',
    method: 'post'
  })
}

// 恢复任务
export function resumeTask() {
  return request({
    url: '/material/fb-scrape/resume',
    method: 'post'
  })
}

// 停止任务
export function stopTask() {
  return request({
    url: '/material/fb-scrape/stop',
    method: 'post'
  })
}

// 检查参数是否修改
export function checkParamsChanged() {
  return request({
    url: '/material/fb-scrape/params-changed',
    method: 'get'
  })
}

// 获取任务日志列表
export function getTaskLogs(params) {
  return request({
    url: '/material/fb-scrape/task-logs',
    method: 'get',
    params: params
  })
}

// 获取明细日志列表
export function getDetailLogs(params) {
  return request({
    url: '/material/fb-scrape/detail-logs',
    method: 'get',
    params: params
  })
}

// 获取当前运行的任务日志
export function getCurrentTaskLog() {
  return request({
    url: '/material/fb-scrape/current-log',
    method: 'get'
  })
}
